<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>edit</v-icon> Modificar permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <p>
                  Tipo de permiso : <strong>{{ permiso.tipo_permiso }}</strong>
                </p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md4>
                <p>
                  <strong>Total horas a compensar:</strong>
                  {{ debe_horas_compensacion }}
                </p>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 v-if="id_permi == 88">
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  type="date"
                  v-model="permiso.fecha_desde"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  required
                  @input="borrarLocalmente()"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  v-if="id_permi == 88"
                  type="time"
                  label="Hora desde"
                  :rules="$validate(['required'])"
                  v-model="permiso.hora_desde"
                  @input="
                    borrarLocalmente() &&
                      verificarRangoMediaHora(false) &&
                      obtieneHorasCompensacion(false)
                  "
                  @change="
                    borrarLocalmente() &&
                      verificarRangoMediaHora(true) &&
                      obtieneHorasCompensacion(true)
                  "
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="id_permi == 88"
                  class="text-field-reducido-border"
                  outline
                  type="time"
                  label="Hora hasta"
                  :rules="$validate(['required'])"
                  v-model="permiso.hora_hasta"
                  @input="
                    borrarLocalmente() &&
                      verificarRangoMediaHora(false) &&
                      obtieneHorasCompensacion(false)
                  "
                  @change="
                    borrarLocalmente() &&
                      verificarRangoMediaHora(true) &&
                      obtieneHorasCompensacion(true)
                  "
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card>
      <v-card-title
        class="headline"
        v-if="bandera_compensacion && bandera_media_hora && !bandera_8horas"
      >
        <v-icon>edit</v-icon> Compensar permiso
        <v-spacer></v-spacer>
      </v-card-title>
      <v-form
        ref="form"
        lazy-validation
        v-if="bandera_compensacion && bandera_media_hora && !bandera_8horas"
      >
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0">
            <v-layout>
              <v-flex md4>
                <p>
                  <strong>Total horas a compensar:</strong>
                  {{ debe_horas_compensacion }}
                </p>
              </v-flex>
            </v-layout>
            <!-- Fecha compensacion -->
            <v-layout>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  required
                  @input="verificaCompensacion()"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-radio-group
                  v-model="form.tipo_dia"
                  @change="verificaCompensacion()"
                >
                  <!-- <v-flex>
                    <v-radio label="Mañana" value="1"></v-radio>
                  </v-flex> -->
                  <v-flex>
                    <v-radio label="Tarde" value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 md6>
                <v-radio-group
                  v-model="form.horario"
                  @change="verificaCompensacion()"
                >
                  <!-- <v-radio label="Ingreso" value="1"></v-radio> -->
                  <v-radio label="Salida" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md6>
                <v-select
                  class="text-field-reducido-border"
                  outline
                  value="hora"
                  :items="rango_horarios"
                  type="hour"
                  item-value="hora"
                  item-text="hora"
                  label="Cantidad de horas"
                  v-model="form.horas_compensa"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  @input="verificaCompensacion()"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  type="time"
                  label="Hora desde"
                  v-model="hora_desde_calculada"
                  disabled
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  type="time"
                  label="Hora hasta"
                  v-model="hora_hasta_calculada"
                  disabled
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="cargarCompensacion()">
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- Detalle compensaacion -->
        <v-card-text class="px-3">
          <h3><strong>Detalles compensacion</strong></h3>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                class="elevation-1 tabla-comprimida-light"
                :items="compensaciones"
                hide-actions
                :headers="headers"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.total_horas }}
                  </td>
                  <td class="text-xs-center">
                    <v-btn
                      color="error"
                      icon
                      title="Eliminar compensacion"
                      @click="borrarCompensacionDetalle(props.item.id)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout class="pa-2">
            <v-flex xs12>
              <h4>
                <strong
                  >Total horas:
                  {{ total_horas_compensacion.format("HH:mm") }}</strong
                >
              </h4>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>
    <v-card>
      <v-card-actions class="pr-4">
        <v-spacer></v-spacer>
        <v-btn @click.native="close()" color="red" dark>
          <v-icon>cancel</v-icon>CERRAR
        </v-btn>
        <v-btn @click.native="save()" color="green" dark>
          <v-icon>check</v-icon>GUARDAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  props: ["item"],
  mounted() {
    this.$bus.$on("openDialogModificarPermisoCompensacion", async item => {
      this.permiso = item;
      this.permiso.fecha_desde = this.permiso.fecha_desde
        .split("/")
        .reverse()
        .join("-");
      this.fecha_desde_guardado = this.permiso.fecha_desde;
      this.hora_desde_guardado = this.permiso.hora_desde;
      this.hora_hasta_guardado = this.permiso.hora_hasta;
      this.id_permi = item.id_tipo_permiso;
      this.per_hora_desde = item.hora_desde;
      this.permi_lugar = item.permiso.lugar;
      this.permi_motivo = item.permiso.motivo;
      this.permiso.motivo = this.permiso.permiso.motivo;
      this.dialog = true;
      await this.obtieneHorasCompensacion(false);
      await this.listCompensaciones();
    });
  },
  data() {
    return {
      total_horas_resguardo: this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      }),
      bandera_media_hora: true,
      compensaciones_resguardo: [],
      fecha_desde_guardado: null,
      hora_desde_guardado: null,
      hora_hasta_guardado: null,
      bandera_borrado: false,
      debe_horas_compensacion: 0,
      dias_de_incapacidad: 0,
      nro_de_dias: 0,
      bandera_file: false,
      dias: 0,
      id_permi: "",
      ruta_a: "",
      file: "",
      dialog: false,
      edit: true,
      dias_habiles: 0,
      permiso: {
        id_tipo_permiso: null,
        motivo: "",
        permi_fecha_hasta: "",
        permi_fecha_desde: ""
      },
      permisos: [],
      tipo_permisos: [],
      permiso_detalle: {},
      valid: false,
      loading: false,

      horas_disponibles: null,
      hora_desde_calculada: "",
      hora_hasta_calculada: "",
      total_horas_calculada: "",
      mensaje_error: "",
      bandera_compensacion: true,
      bandera_8horas: false,
      correlativo_compensacion: 0,
      total_horas_compensacion: this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      }),
      form: {},
      rango_horarios: [
        {
          hora: "00:30"
        },
        {
          hora: "01:00"
        },
        {
          hora: "01:30"
        },
        {
          hora: "02:00"
        },
        {
          hora: "02:30"
        },
        {
          hora: "03:00"
        },
        {
          hora: "03:30"
        },
        {
          hora: "04:00"
        },
        {
          hora: "04:30"
        },
        {
          hora: "05:00"
        },
        {
          hora: "05:30"
        }
      ],
      compensaciones: [],

      headers: [
        {
          text: "Fecha",
          align: "center",
          sortable: false
        },
        {
          text: "Hora desde",
          align: "center",
          sortable: false
        },
        {
          text: "Hora hasta",
          align: "center",
          sortable: false
        },
        {
          text: "Total Horas",
          align: "center",
          sortable: false
        },
        {
          text: "Acción",
          align: "center",
          sortable: false
        }
      ],
      permiso_detalles: [],
      permisoDetalle: []
    };
  },

  methods: {
    async verificarRangoMediaHora(bandera_mensaje) {
      if (this.permiso.hora_desde && this.permiso.hora_hasta) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_valida_rangos_media_hora('${this.permiso.hora_desde}','${this.permiso.hora_hasta}')"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_valida_rangos_media_hora;
          respuesta = respuesta.split("|");
          if (respuesta[0] == "1") {
            this.bandera_media_hora = true;
          } else {
            if (bandera_mensaje) {
              this.$message.info(respuesta[1]);
            }
            this.bandera_media_hora = false;
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async borrarLocalmente() {
      if (
        this.fecha_desde_guardado == this.permiso.fecha_desde &&
        this.hora_desde_guardado == this.permiso.hora_desde &&
        this.hora_hasta_guardado == this.permiso.hora_hasta
      ) {
        this.bandera_borrado = false;
        this.total_horas_compensacion = this.$moment().set({
          hour: 0,
          minutes: 0,
          seconds: 0
        });
        await this.listCompensaciones();
      } else {
        this.compensaciones = [];
        this.bandera_borrado = true;
        this.total_horas_compensacion = this.$moment().set({
          hour: 0,
          minutes: 0,
          seconds: 0
        });
      }
    },
    async listCompensaciones() {
      try {
        // SELECT * FROM CONTROL.permiso_compensacion  WHERE id_permiso = 220539
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select * FROM CONTROL.permiso_compensacion  WHERE id_permiso=${this.permiso.id_permiso} "){
                  respuesta
                }
              }
            `
        });
        respuesta = respuesta.runQuery.respuesta;
        for (let index = 0; index < respuesta.length; index++) {
          const element = respuesta[index];
          element.total_horas = this.$moment(element.hora_hasta, "HH:mm")
            .subtract(element.hora_desde, "HH:mm")
            .format("HH:mm");
          this.total_horas_compensacion.add(element.total_horas);
          this.total_horas_resguardo.add(element.total_horas);
        }
        this.compensaciones = respuesta;
        this.compensaciones_resguardo = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    borrarCompensacionDetalle(id) {
      this.$confirm("¿Esta seguro de eliminar el registro?", () => {
        let posicion;
        let compensaciones_aux = [];
        for (let index = 0; index < this.compensaciones.length; index++) {
          const element = this.compensaciones[index];
          if (element.id != id) {
            compensaciones_aux.push(element);
          } else {
            this.total_horas_compensacion.subtract(element.total_horas);
          }
        }
        this.compensaciones = compensaciones_aux;
      });
    },
    async obtieneHorasCompensacion(bandera_mensaje) {
      if (
        this.permiso.hora_desde &&
        this.permiso.hora_desde &&
        this.permiso.fecha_desde
      ) {
        try {
          let id_persona = this.getPersonaId();
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_corresponde_compensacion_actualiza(${id_persona},'${
              this.permiso.fecha_desde
            }','${this.permiso.hora_desde}','${
              this.permiso.hora_hasta
            }',${parseInt(this.permiso.id_permiso)})"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0]
              .fn_corresponde_compensacion_actualiza;
          respuesta = respuesta.split("|");
          if (respuesta[0] == "SI") {
            if (bandera_mensaje) {
              this.$message.info("Debe compensar horas");
            }
            this.bandera_8horas = false;
            this.debe_horas_compensacion = respuesta[1];
            this.bandera_compensacion = true;
          } else if (respuesta[0] == "NO") {
            this.debe_horas_compensacion = this.$moment()
              .set({
                hour: 0,
                minutes: 0,
                seconds: 0
              })
              .format("HH:mm");
            this.total_horas_compensacion = "00:00";
            this.bandera_compensacion = false;
          } else {
            this.bandera_8horas = true;
            if (bandera_mensaje) {
              this.$message.info(respuesta[1]);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async verificaCompensacion() {
      try {
        // SELECT control.fn_obtine_rangos_compensacion(
        //   p_id_persona integer,
        //   p_fecha_compensacion date,
        //   p_tipo_dia integer,
        //   p_horario integer,
        //   p_horas character,
        // p_fecha_permiso date,
        // p_hora_desde character VARYING,
        // p_hora_hasta character VARYING
        // )
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculad = "";
        if (
          this.form.fecha_desde &&
          this.form.tipo_dia &&
          this.form.horario &&
          this.form.horas_compensa &&
          this.permiso.fecha_desde &&
          this.permiso.hora_desde &&
          this.permiso.hora_hasta
        ) {
          let id_persona = this.getPersonaId();
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_obtine_rangos_compensacion(${id_persona},'${
              this.form.fecha_desde
            }',${parseInt(this.form.tipo_dia)},${parseInt(
              this.form.horario
            )},'${this.form.horas_compensa}','${this.permiso.fecha_desde}','${
              this.permiso.hora_desde
            }','${this.permiso.hora_hasta}')"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_obtine_rangos_compensacion;
          let horarios = respuesta.split("|");
          if (horarios[0] != "0") {
            this.hora_desde_calculada = horarios[1];
            this.hora_hasta_calculada = horarios[2];
            this.total_horas_calculada = horarios[3];
          } else {
            this.mensaje_error = horarios[1];
            this.$message.info(this.mensaje_error);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    cargarCompensacion() {
      if (
        this.form.fecha_desde &&
        this.form.tipo_dia &&
        this.form.horario &&
        this.form.horas_compensa &&
        this.hora_desde_calculada &&
        this.hora_hasta_calculada &&
        this.total_horas_calculada
      ) {
        let compensacion_crear = {
          id: this.correlativo_compensacion,
          fecha_desde: this.form.fecha_desde,
          hora_desde: this.hora_desde_calculada,
          hora_hasta: this.hora_hasta_calculada,
          total_horas: this.total_horas_calculada
        };
        this.compensaciones.push(compensacion_crear);
        this.correlativo_compensacion += 1;
        this.form.fecha_desde = "";
        this.form.tipo_dia = "";
        this.form.horario = "";
        this.form.horas_compensa = "";
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculada = "";
        this.$message.success("Registro exitoso");
        this.total_horas_compensacion.add(compensacion_crear.total_horas);
      } else {
        if (this.mensaje_error) {
          this.$message.warning(this.mensaje_error);
        } else {
          this.$message.warning("Revise si lleno todos los campos requeridos");
        }
      }
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async verificarPermisosRango(
      fecha_desde,
      fecha_hasta,
      hora_desde,
      hora_hasta,
      id_permiso
    ) {
      //Funcion notifica que hay un permiso creado en el rango de fechas seleccionado
      // control.fn_muestra_permisos_funcionario(p_id_persona integer, p_fecha date)
      let existePermisos = false;
      let permisos = "¿Esta seguro guardar el permiso?";
      let permisos_consulta = "";
      let respuesta;
      console.log(`
              query{
                runQuery(consulta:"select control.fn_permisos_por_funcionario_actualiza(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}',${parseInt(
        id_permiso
      )})"){
                  respuesta
                }
              }
            `);
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_permisos_por_funcionario_actualiza(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}',${parseInt(
            id_permiso
          )})"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_permisos_por_funcionario_actualiza;
        respuesta = respuesta.split("|");
        console.log(respuesta);
        if (respuesta[0] == "1") {
          existePermisos = true;
          permisos_consulta +=
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            respuesta[1].replace(/#/g, "<br>");
        }
      } catch (error) {
        console.log(error);
      }
      console.log(permisos);
      if (existePermisos) {
        this.$alert("No puede crear el permiso" + permisos_consulta);
      }
      return [existePermisos, permisos + permisos_consulta];
    },
    // async obtenerHorarioPersona(id_persona, id_radio_data) {
    //   try {
    //     let respuesta = await this.$service.graphql({
    //       query: `
    //         query{
    //           runQuery(consulta:"select control.fn_rango_horario_por_persona_solo_horarios(${parseInt(
    //             id_persona
    //           )},${parseInt(id_radio_data)})"){
    //             respuesta
    //           }
    //         }
    //       `
    //     });
    //     respuesta = respuesta.runQuery.respuesta[0].fn_rango_horario_por_persona_solo_horarios.split(
    //       "|"
    //     );
    //     if (respuesta[0] != "0") {
    //       return [respuesta[0], respuesta[1]];
    //     } else {
    //       return -1;
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    close() {
      this.dialog = false;
      this.permiso = {
        id_tipo_permiso: null,
        motivo: ""
      };
      this.total_horas_compensacion = this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      });

      this.edit = true;
      this.$bus.$emit("closeDialogModificarPermisoCompensacion");
    },
    //verifica que una vacacion aprobada no choque con el permiso:
    async verificaVacaciones(fecha_desde, fecha_hasta) {
      let existe_vacacion = false;
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select vacaciones.fn_verifica_coincidencia_de_vacaciones_aprobadas(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_verifica_coincidencia_de_vacaciones_aprobadas;

        if (respuesta != "0") {
          existe_vacacion = true;
          permisos_consulta +=
            "<br><strong>Usted tiene la siguiente vacación aprobada en las fechas solicitadas:</strong><br>" +
            respuesta.replace(/#/g, "<br>");
          this.$message.warning(permisos_consulta);
        }
        return existe_vacacion;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      if (
        this.$moment(this.total_horas_compensacion, "HH:mm").format("HH:mm") ==
        this.$moment(this.debe_horas_compensacion, "HH:mm").format("HH:mm")
      ) {
        //consulta si existe una vacacion aprobada en ese rango de fechas
        let verifica_vacacion = await this.verificaVacaciones(
          this.permiso.fecha_desde,
          this.permiso.fecha_desde
        );
        if (verifica_vacacion == true) {
          return;
        }
        //consulta si existe un permiso aprobado en ese rango de fechas
        let consulta = await this.verificarPermisosRango(
          this.permiso.fecha_desde,
          this.permiso.fecha_desde,
          this.permiso.hora_desde,
          this.permiso.hora_hasta,
          this.permiso.id_permiso
        );
        if (consulta[0] == true) {
          return;
        }
        this.$confirm(consulta[1], async () => {
          let resps;
          let respuesta;
          let correcto;
          resps = [];
          let user = this.$storage.get("user");
          let id_permiso_creado = this.permiso.id_permiso;
          let fecha_actual = this.$moment().format("YYYY-MM-DD");

          // control.fn_actualiza_permiso_particular(
          // p_id_permiso integer,
          // p_motivo character varying,
          // p_fecha_permiso date,
          // p_lugar character varying,
          // p_id_funcionario integer,
          // p_fecha_desde date,
          // p_fecha_hasta date,
          // p_hora_desde character varying,
          // p_hora_hasta character varying)
          try {
            respuesta = await this.$service.graphql({
              query: `
                  query{
                    runQuery(consulta:"select control.fn_actualiza_permiso_particular(${id_permiso_creado},'','${fecha_actual}','',${user.id},'${this.permiso.fecha_desde}','${this.permiso.fecha_desde}','${this.permiso.hora_desde}','${this.permiso.hora_hasta}',${this.permiso.rol})"){
                          respuesta
                      }
                    }
                  `
            });
            let respuesta2 =
              respuesta.runQuery.respuesta[0].fn_actualiza_permiso_particular;
            resps = respuesta2.split("|");
            correcto = resps[0];
            if (correcto == "1") {
              // this.$message.success("Modificación exitosa permiso");
              //Borrando compensaciones
              //control.fn_elimina_compensacion_por_permiso(p_id_permiso integer)
              try {
                respuesta = await this.$service.graphql({
                  query: `
                query{
                  runQuery(consulta:"select control.fn_elimina_compensacion_por_permiso(${id_permiso_creado})"){
                        respuesta
                    }
                  }
                `
                });
                let respuesta2 =
                  respuesta.runQuery.respuesta[0]
                    .fn_elimina_compensacion_por_permiso;
                resps = respuesta2.split("|");
                correcto = resps[0];
                // if (correcto == "1") {
                //   this.$message.success("Borrado exitoso")
                // } else {
                //   this.$message.error(resps[1])
                // }
              } catch (error) {
                console.log(error);
              }
              try {
                // Guarda compensaciones
                let esCorrecto = true;
                for (
                  let index = 0;
                  index < this.compensaciones.length;
                  index++
                ) {
                  const element = this.compensaciones[index];
                  let respuesta_comp = await this.$service.graphql({
                    query: `
                      query{
                          runQuery(consulta:"select control.fn_registra_compensacion_y_o_elimina(${id_permiso_creado},'${element.fecha_desde}','${element.fecha_desde}','${element.hora_desde}','${element.hora_hasta}',${user.id})"){
                              respuesta
                          }
                        }
                      `
                  });
                  let respuesta3 =
                    respuesta_comp.runQuery.respuesta[0]
                      .fn_registra_compensacion_y_o_elimina;
                  resps = respuesta3.split("|");
                  if (resps[0] == "0") {
                    this.$confirm(resps[1], () => {});
                    esCorrecto = false;
                    break;
                  }
                }
                if (esCorrecto) {
                  this.$confirm("Modificación exitosa", () => {
                    this.close();
                  });
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              this.$confirm(resps[1], () => {});
            }
          } catch (error) {
            console.log(error);
          }

          // else {
          //   //control.fn_registra_compensacion_y_o_elimina(
          //   // p_id_permiso integer,
          //   // p_fecha_desde date,
          //   // p_fecha_hasta date,
          //   // p_hora_desde character varying,
          //   // p_hora_hasta character varying,
          //   // p_id_funcionario integer)

          //   let esCorrecto = true;
          //   for (let index = 0; index < this.compensaciones_resguardo.length;index++) {
          //     const element = this.compensaciones_resguardo[index];
          //     let respuesta_comp = await this.$service.graphql({
          //       query: `
          //           query{
          //               runQuery(consulta:"select control.fn_registra_compensacion_y_o_elimina(${id_permiso_creado},'${element.fecha_desde}','${element.fecha_desde}','${element.hora_desde}','${element.hora_hasta}',${user.id})"){
          //                   respuesta
          //               }
          //             }
          //           `
          //     });
          //     console.log("respuest respaldo",respuesta)
          //     let respuesta3 =
          //       respuesta_comp.runQuery.respuesta[0]
          //         .fn_registra_compensacion_y_o_elimina;
          //     resps = respuesta3.split("|");
          //     if (resps[0] == "0") {
          //       this.$confirm(resps[1], () => {});
          //       esCorrecto = false;
          //       break;
          //     }
          //   }
          //   if (esCorrecto) {
          //     this.$confirm("Registro exitoso", () => {
          //       this.close()
          //     });
          //   }
          // }
        });
      } else {
        this.$message.warning("Le faltan horas que compensar");
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/ModificarPermisoCompensacion.vue